import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "submit-application" }
const _hoisted_2 = { class: "submit-application__sides" }
const _hoisted_3 = { class: "left-side" }
const _hoisted_4 = { class: "side-content" }
const _hoisted_5 = { class: "right-side" }
const _hoisted_6 = { class: "side-content" }
const _hoisted_7 = { class: "submit-application__sides__privacy" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "content__title" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "submit-application__sides__process" }
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "content__title" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]

import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import TextWithTag from '@/profile-creation-wizard/common/ui/TextWithTag.vue';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import {CreationStepName} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';
    import {useTranslation} from '@malt/vue3-use';
    import {inject, ref} from 'vue';
    import {useRouter} from 'vue-router';
    import {ApplicationStateActions} from '../../domain/application-state/ApplicationState';
    import {track} from '@malt/tracking';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationSubmitStep',
  setup(__props) {

    const applicationStateRepository = inject(DI.applicationStateRepository)!;
    const trackingRepository = inject(DI.trackingRepository)!;

    const router = useRouter();
    const {msg} = useTranslation();
    const isLoading = ref(false);

    async function submitApplication() {
        isLoading.value = true;

        try {
            await applicationStateRepository.updateApplicationState(ApplicationStateActions.SUBMIT);
            await track(`application_submitted`);
            await trackingRepository!.track(`submit-application-sent-strategy`);
            router.push({name: CreationStepName.WAITING_ROOM});
        } catch (e) {
            pushVJoySnackbar({
                props: {
                    message: msg('profile.creation.common.notification.error.technical'),
                    level: 'error',
                },
            });
        } finally {
            isLoading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyButton = _resolveComponent("VJoyButton")!

  return (_openBlock(), _createBlock(Step, {
    "show-stepper": true,
    "show-buttons": false,
    "progress-bar": false,
    "full-screen": true
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(TextWithTag, {
                isFunnelStrategy: true,
                class: "side-content__title"
              }, {
                "text-before-tag": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.submitapplication.tag.1')), 1)
                ]),
                "text-with-tag": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.submitapplication.tag.2')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("joy-icon", { name: "lock" }, null, -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.submitapplication.privacy.1')), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", {
                    innerHTML: _unref(msg)('profile.creation.completion.wizard.submitapplication.privacy.2')
                  }, null, 8, _hoisted_10)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[3] || (_cache[3] = _createElementVNode("joy-icon", { name: "view-user" }, null, -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.submitapplication.process.1')), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", {
                    innerHTML: _unref(msg)('profile.creation.completion.wizard.submitapplication.process.2')
                  }, null, 8, _hoisted_14)
                ])
              ]),
              _createVNode(_component_VJoyButton, {
                "data-testid": "cta-submit-application",
                class: "submit-application__sides__button",
                variant: "main",
                loading: isLoading.value,
                onClick: submitApplication
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: _unref(msg)('profile.creation.completion.wizard.submitapplication.cta.submit')
                  }, null, 8, _hoisted_15)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})